module.exports = __webpack_public_path__ + "img/step-2.568e75e8.gif";